module.exports = __webpack_public_path__ + "static/media/google-play-badge.b8a7e583.png";